import React, { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { toast } from 'react-toastify';
import api from '../../../services/API';
import NumberFormat from 'react-number-format';
import { formatNumber, formatCurrency } from '../../../utils/formatNumber';

export default function ConfiguracoesGerais() {
  const [configuracoes, setConfiguracoes] = useState({
    limiteValorPontuacaoCliente: 0,
    limiteQuantidadePontuacaoCliente: 0,
  });
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    carregarConfiguracoes();
  }, []);

  const carregarConfiguracoes = async () => {
    try {
      setLoading(true);
      const response = await api.get('/api/configuracoes-gerais');
      if (response.data) {
        setConfiguracoes({
          limiteValorPontuacaoCliente: response.data.limiteValorPontuacaoCliente || 0,
          limiteQuantidadePontuacaoCliente: response.data.limiteQuantidadePontuacaoCliente || 0,
        });
      }
    } catch (error) {
      console.error('Erro ao carregar configurações:', error);
      toast.error('Erro ao carregar configurações', {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 5000,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setConfiguracoes(prev => ({
      ...prev,
      [name]: parseFloat(value) || 0,
    }));
  };

  const handleValueChange = (values) => {
    const { value } = values;
    setConfiguracoes(prev => ({
      ...prev,
      limiteValorPontuacaoCliente: parseFloat(value) || 0,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      setSaving(true);
      await api.put('/api/configuracoes-gerais', configuracoes);
      
      toast.success('Configurações salvas com sucesso!', {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 5000,
      });
    } catch (error) {
      console.error('Erro ao salvar configurações:', error);
      toast.error('Erro ao salvar configurações', {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 5000,
      });
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <Container fluid>
        <div className="d-flex justify-content-center pt-5">
          <div className="spinner-border" role="status">
            <span className="sr-only">Carregando...</span>
          </div>
        </div>
      </Container>
    );
  }

  return (
    <Container fluid>
      <div>
        <h4 className="pt-3 pb-3 f-black">Configurações Gerais</h4>
        <hr className="hr-loja mt-0 mb-5" />
      </div>
      
      <div className="d-flex flex-column align-items-center">
        <form className="form" onSubmit={handleSubmit}>
          <div className="row w-100 align-items-end">
            <div className="col-md-6 mb-3">
              <label htmlFor="limiteValorPontuacaoCliente">
                Valor Limite de Pontuação Cliente
              </label>
              <input
                type="text"
                id="limiteValorPontuacaoCliente"
                name="limiteValorPontuacaoCliente"
                value={formatCurrency(configuracoes.limiteValorPontuacaoCliente)}
                onChange={handleInputChange}
                placeholder="Digite o valor limite"
                className="form-control"
              />
              <small className="text-muted">
                Valor máximo permitido para pontuação do tipo Cliente. Se o usuário preencher um valor maior, será exibido um modal de confirmação.
              </small>
            </div>
            <div className="col-md-6 mb-3">
              <label htmlFor="limiteQuantidadePontuacaoCliente">
                Quantidade Limite Cliente
              </label>
              <input
                type="number"
                id="limiteQuantidadePontuacaoCliente"
                name="limiteQuantidadePontuacaoCliente"
                value={formatNumber(configuracoes.limiteQuantidadePontuacaoCliente, 0)}
                onChange={handleInputChange}
                step="1"
                min="0"
                placeholder="Digite a quantidade limite"
                className="form-control"
              />
              <small className="text-muted">
                Quantidade máxima permitida para pontuação do tipo Cliente. Se o usuário preencher uma quantidade maior, será exibido um modal de confirmação.
              </small>
            </div>
          </div>

          <div className="row w-100">
            <div className="col-md-12 d-flex justify-content-center">
              <button className="btn-primario w-100 mt-2" type="submit" disabled={saving}>
                {saving ? 'SALVANDO...' : 'SALVAR CONFIGURAÇÕES'}
              </button>
            </div>
          </div>
        </form>
      </div>
    </Container>
  );
} 